import mapboxgl, { Marker } from "mapbox-gl"; // or "const mapboxgl = require('mapbox-gl');"
import "mapbox-gl/dist/mapbox-gl.css";
import accordion from "./components/accordion";
import throttle from "./utils/throttle";

export default function agentsNetworkJs() {
	window.addEventListener(
		"resize",
		throttle(function () {
			initAccordion();
			// your code goes here
		}, 1000)
	);


	mapboxgl.accessToken =
		"pk.eyJ1IjoiNzdhbGV4NzciLCJhIjoiY2t6bzVzcnZoMXY2aDJvbGx4enN5a2gyNCJ9.uQ1iPab4hViuUUsR1MGV2A";

	let geojson = [];

	let map = new mapboxgl.Map({
		container: "map",
		// Choose from Mapbox's core styles, or make your own style with Mapbox Studio
		style: "mapbox://styles/77alex77/cl9fiee7o001414ozm5h9042f",
		center: [18.05, 41.51],
		zoom: 5,
	});
	const initialCenter = map.getCenter();
	const initialZoom = map.getZoom();
	const initialBearing = map.getBearing();
	const initialPitch = map.getPitch();

	async function fetchProducts() {
		try {
			const response = await fetch(
				"/umbraco/surface/AgencyNetwork/GetCountries"
			);
			if (!response.ok) {
				throw new Error(`HTTP error: ${response.status}`);
			}
			const data = await response.json();
			geojson = JSON.parse(JSON.stringify(data));
			geojson.map((record) => {
				addMarkers(record.ports, record.countryName);
			});
		} catch (error) {
			error == "e.getCanvasContainer is not a function" && location.reload();
			console.error(`Could not get products: ${error}`);
		}
		// setTimeout(() => {
		// }, 500);
	};
	fetchProducts()
	function initAccordion() {
		window.innerWidth > 640
			? document.querySelectorAll('[data-js="accordion"]').forEach((elem) => {
				accordion(elem, true);
			})
			: document.querySelectorAll('[data-js="accordion"]').forEach((elem) => {
				accordion(elem, true, undefined, 400);
			});
	}
	initAccordion();

	const agencyCard = document.querySelector("#agency_card");
	const cardContainer = document.querySelector(".cardContainer");

	let lastCity = "";
	function addMarkers(array, country) {
		array.map((port) => {
			const el = document.createElement("div");
			const elSpan = document.createElement("span");
			el.className = "marker";
			elSpan.innerHTML = port.portName;
			el.append(elSpan);
			el.addEventListener("click", () => {
				document.querySelector("#map").scrollIntoView({ block: "end" });
				let activeMarker = document.querySelector(".marker.active");
				activeMarker && activeMarker.classList.remove("active");
				if (cardContainer.classList.contains("show")) {

					if (lastCity == port.portName) {
						cardContainer.classList.remove("show");
						el.classList.remove("active");
					} else {
						// activeMarker && activeMarker.classList.remove("active");
						el.classList.add("active");
						lastCity = port.portName;
					}
				} else {
					activeMarker && activeMarker.classList.remove("active");
					cardContainer.classList.add("show");
					el.classList.add("active");
					lastCity = port.portName;
				}

				agencyCard.innerHTML = `<h4 class=" text-sm md:text-lg font-normal">Agent Info</h4>
				<address class=" not-italic sm:grid grid-cols-[auto_auto] grid-rows-[auto_auto] sm:ml-[calc(202_/_1712_*_100%)]">
					<span property="country" class=" not-italic block text-black/50 md:text-black text-sm md:text-lg font-medium md:font-normal mt-6 sm:row-start-2 sm:col-start-1">${country}</span>
					<span property="city" class=" block text-[calc(35_/_16_*_1rem)] md:text-[calc(95_/_16_*_1rem)] font-medium leading-none mt-2 sm:mt-0 sm:row-start-1 sm:col-[1_/_-1]">${port.portName}</span>
					<div class=" font-medium text-sm mt-6 md:mt-6 flex flex-col gap-y-2 sm:col-start-2 sm:row-start-2 sm:ml-[calc(95_/_297_*_100%)]">
						<span>${port.agentAddress}</span>
						<div>Tel: <a class=" sm:hidden" href="tel:${port.agentPhone}">${port.agentPhone}</a> <span class=" hidden sm:inline-block">${port.agentPhone}</span>
						</div>
						<a href="mailto:${port.agentEmail}">${port.agentEmail}</a>
		
					</div>
				</address>
				<a href="${port.agentLink?.url}" class=" sm:ml-auto sm:self-end relative w-min whitespace-nowrap font-Beausite text-base md:text-xl font-medium tracking-[calc(-0.18_/_1000_*_1em)] leading-[calc(23_/_20_*_1em)] pr-[calc(25_/_20_*_1em)]
				before:content-[''] before:w-[calc(16_/_16_*_1em)] before:h-[calc(16_/16_*_1em)] before:bg-[url('../../images/arrow-aside.svg')] before:bg-no-repeat before:bg-center before:bg-contain before:absolute before:right-0 before:top-1/2 before:-translate-y-1/2 before:translate-x-0 before:transition-all hover:before:translate-x-1/2">${port.agentLink?.name}</a>`;
			});
			new mapboxgl.Marker(el).setLngLat(port.coordinates).addTo(map);
		});
	}

	map.scrollZoom.disable();
	map.addControl(new mapboxgl.NavigationControl(), "bottom-right");
	const countries = document.querySelectorAll("#countries .country");

	getGuid("guid", countries, revealGuid);

	function getGuid(data, selectors, callback) {
		selectors.forEach((elem) => {
			const elemGuid = elem.dataset[data];
			elem.addEventListener("click", function (e) {
				e.preventDefault();
				callback(elemGuid);
			});
		});
	}

	function revealGuid(guid) {
		const insertedMarkers = document.querySelectorAll(".marker");
		insertedMarkers.forEach((elem) => elem.remove());
		const countryPorts = geojson.filter((record) => {
			return record.countryName == guid;
		});
		map.flyTo({
			center: countryPorts[0].center,
			zoom: window.innerWidth < 768 ? 4 : 5,
		});
		addMarkers(countryPorts[0].ports, guid);
		document.getElementById("map").style.scrollMarginTop = 68 + "px";
		document.getElementById("map").scrollIntoView();
		cardContainer.classList.remove("show");
	}

	const resetCountries = document.querySelector("#resetCountries")
	resetCountries.addEventListener("click", function () {
		fetchProducts();
		map.flyTo({
			center: initialCenter,
			zoom: initialZoom,
			bearing: initialBearing,
			pitch: initialPitch,
			speed: 1
		  });
	});

}

// const accordionBtn = document.querySelector('[data-js="accordion-toggler"]')
// const accordionContent = document.querySelector('[data-js="accordion_contents"]')

// accordionBtn.addEventListener("click", function() {
// 	accordionContent.classList.add("animateEl", "fadeIn");
// })
